export const CREATE_CREDIT_CARD_PENDING = 'redux-app/credit-cards/CREATE_CREDIT_CARD_PENDING';
export const CREATE_CREDIT_CARD_SUCCESS = 'redux-app/credit-cards/CREATE_CREDIT_CARD_SUCCESS';
export const CREATE_CREDIT_CARD_FAIL = 'redux-app/credit-cards/CREATE_CREDIT_CARD_FAIL';

export const CREATE_CREDIT_CARD_TOKEN_PENDING = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_PENDING';
export const CREATE_CREDIT_CARD_TOKEN_SUCCESS = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_SUCCESS';
export const CREATE_CREDIT_CARD_TOKEN_FAIL = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_FAIL';
export const CREATE_CREDIT_CARD_TOKEN_RESET = 'redux-app/credit-cards/CREATE_CREDIT_CARD_TOKEN_RESET';
